import {AppActions, useAppContext} from "../../context/AppContext";
import {useUser} from "../../context/UserContext";
import {useMapSync} from "../../context/MapSyncContext";
import 'leaflet-arrowheads';
import 'leaflet-polylinedecorator';
import 'leaflet-simple-map-screenshoter'
import 'leaflet-control-mini-map/dist/minimap.css';
import 'leaflet-measure'
import 'leaflet-measure/dist/leaflet-measure.css'
import 'leaflet-kmz'
import 'leaflet-geometryutil'
import 'leaflet-draw'
import 'leaflet-snap'
import 'leaflet.markercluster'
import 'leaflet-search'
import 'leaflet-search/dist/leaflet-search.min.css'
import 'leaflet/dist/images/marker-icon-2x.png'

import _ from 'lodash'
import {SimpleMapScreenshoter} from 'leaflet-simple-map-screenshoter'
import {useEffect, useRef, useState} from "react";
import {useModal} from "../../context/ModalContext";
import {v4} from "uuid";
import KML from "../map-plugins/KML";
import MouseCoord from "../map-plugins/MouseCoord";
import proj4 from "proj4";
import MeasureTool from "../map-plugins/MeasureTool";
import FullExtend from "../map-plugins/FullExtend";
import TileSelect from "../map-plugins/TileSelect";
import ProfileSelect from "../map-plugins/ProfileSelect";
import {MapContainer} from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css'
import {notification, Space, Spin, Progress} from "antd";
import '@meteo-concept/leaflet-inflatable-markers-group';
import '../../styles/map-view.css'
import CrossSectionWindow from "../outputs/ui/CrossSection/CrossSectionWindow";
import ReactDOMServer from 'react-dom/server';
import {BridgeTable, CulvertTable} from "../outputs/internal/B40";
import ShapeFileHelper from "../../helpers/ShapeFileHelper";
import ShapeItem, {ShapeTooltip} from "./ShapeItem";
import StructureName from "../map-plugins/StructureName";
import MapProjectInfo from "../map-plugins/MapProjectInfo";
import createLeafletPopup from "../../components/CreateLeafletPopup";
import FlowChangeTable from "./FlowChangeTable";
import HecRasHelper from "../../helpers/HecRasHelper";
import BoundaryTable from "./BoundaryTable";
import LayerSearch from "../map-plugins/LayerSearch";
import ResultTable from "../../components/table/ResultTable";
import ResultRow from "../../components/table/ResultRow";
import ResultHeaderCell from "../../components/table/ResultHeaderCell";
import LayerSelectLeaflet from "../map-plugins/LayerSelectLeaflet";
import {createRoot} from 'react-dom/client';
import ShapeTable from "./ShapeTable";
import ResultBodyCell from "../../components/table/ResultBodyCell";
import GeoRasterLayer from "georaster-layer-for-leaflet";
import parseGeoraster from 'georaster'
import MapTypeSwitchButton from "../map-plugins/MapTypeSwitch";
import ProjectionSelect from "../map-plugins/ProjectionSelect";
import {DEFAULT_PROJECTION, loadProjectionText, getProjectionLabel, findProjectionKeyByText} from "../../helpers/ProjectionHelper";


const getTiles = () => {
    return [
        {tile: 'Google Street', url: 'http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', options: {subdomains:['mt0','mt1','mt2','mt3'], maxZoom: 25}, textColor: 'black', csColor: 'green', structure: '#808080'},
        {tile: 'Google Hybrid', url: 'http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', options: {subdomains:['mt0','mt1','mt2','mt3'], maxZoom: 25}, textColor: 'white', csColor: '#39FF14', structure: 'yellow'},
        {tile: 'Google Satellite', url: 'http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', options: {subdomains:['mt0','mt1','mt2','mt3'], maxZoom: 25}, textColor: 'white', csColor: '#39FF14', structure: 'yellow'},
        {tile: 'Google Terrain', url: 'http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', options: {subdomains:['mt0','mt1','mt2','mt3'], maxZoom: 25}, textColor: 'black', csColor: 'green', structure: '#808080'},
        {tile: 'USGS The National Map (TNM)', url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}', options: {maxZoom: 25}, textColor: 'black', csColor: 'green', structure: '#808080'},
        {tile: 'USGS Imagery Only', url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer/tile/{z}/{y}/{x}', options: {maxZoom: 25}, textColor: 'white', csColor: '#39FF14', structure: 'yellow'},
        {tile: 'USGS Topo', url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryTopo/MapServer/tile/{z}/{y}/{x}', options: {maxZoom: 25}, textColor: 'white', csColor: '#39FF14', structure: 'yellow'},
        {tile: 'OpenStreetMap', url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        // {tile: 'ArcGIS USA Topo', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/USA_Topo_Maps/MapServer/tile/{z}/{y}/{x}', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        {tile: 'ArcGIS World Street Map', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        {tile: 'ArcGIS World Imagery', url: 'https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', textColor: 'white', csColor: '#39FF14', options: {maxZoom: 25}, structure: 'yellow'},
        // {tile: 'ArcGIS NatGeo World Map', url: 'https://services.arcgisonline.com/arcgis/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}\n', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        // {tile: 'ArcGIS Physical World Map', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Physical_Map/MapServer/tile/{z}/{y}/{x}', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        // {tile: 'ArcGIS World Shaded Relief', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        // {tile: 'ArcGIS World Terrain Base', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Terrain_Base/MapServer/tile/{z}/{y}/{x}', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        {tile: 'ArcGIS World Topo Map', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        {tile: 'ArcGIS USA', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        {tile: 'None', url: '', options: {maxZoom: 25}, textColor: 'black', csColor: 'green', structure: '#808080', isBlank: true},
    ]
}

const getCenter = (coords) => {
    let sum_x = 0;
    let sum_y = 0;

    for (const coord of coords) {
        sum_x += coord[0]
        sum_y += coord[1]
    }

    return [sum_x/coords.length, sum_y/coords.length]
}


export default function MapView({type, currentMapType, projection, filter, projectInfo, updateKey, mapData, projectLayers, onProjectLayerChange, riverBoundingCoords, selectedRS, mapSize, highlightSurvey = [], onTypeChange, hasCompareData, onMapReady, isSideBySide, controlPosition = 'topleft', sharedTile, onSharedTileChange, isVisible = true}) {
    const {dispatchProject, mapContext} = useAppContext()
    const {user, setSettings} = useUser()
    const { setSharedView, getSharedView } = useMapSync()
    
    // Determine which type to show on the button (sidebyside when in side-by-side mode)
    const buttonType = currentMapType || type
    
    // Model layers userSettings'ten oku
    const modelLayers = user?.settings?.map_settings?.model_layers || mapContext[type]?.selectedLayers?.model || []
    
    // Get user preference projection
    const userPreferenceProjection = user?.settings?.defaults?.spatial_projection || DEFAULT_PROJECTION
    
    // Determine effective projection: project projection if available, otherwise user preference
    const getEffectiveProjection = async () => {
        if (projection) {
            // Try to detect the actual projection name from WKT
            const detectedKey = findProjectionKeyByText(projection)
            const projName = detectedKey ? getProjectionLabel(detectedKey) : 'Custom'
            return { text: projection, name: projName, isProject: true }
        }
        // Load user preference projection
        const projText = await loadProjectionText(userPreferenceProjection)
        if (projText) {
            return { text: projText, name: getProjectionLabel(userPreferenceProjection), isProject: false }
        }
        // Fallback to NC
        const fallbackText = await loadProjectionText(DEFAULT_PROJECTION)
        return { text: fallbackText, name: getProjectionLabel(DEFAULT_PROJECTION), isProject: false }
    }
    
    // Get initial projection name
    const getInitialProjectionName = () => {
        if (!projection) return getProjectionLabel(DEFAULT_PROJECTION)
        const detectedKey = findProjectionKeyByText(projection)
        return detectedKey ? getProjectionLabel(detectedKey) : 'Custom'
    }
    
    const [map, setMap] = useState(null)
    const [activeProjection, setActiveProjection] = useState({ text: projection, name: getInitialProjectionName(), isProject: !!projection })
    const mouseCoordRef = useRef(null)
    const isReady = useRef(false)
    const typeRef = useRef(type)
    const [size, setSize] = useState(mapSize || {height: window.innerHeight - 125, width: window.innerWidth-2})
    const {openModal, closeModal} = useModal()
    const [localTile, setLocalTile] = useState(getTiles()[0])
    
    // FEMA loading progress state
    const [femaProgress, setFemaProgress] = useState(null)
    
    // Use shared tile if provided, otherwise use local tile
    const tile = sharedTile || localTile
    const setTile = onSharedTileChange || setLocalTile
    
    const tileRef = useRef(tile)
    const [profile, setProfile] = useState(null)
    const prevSelectedRS = useRef(selectedRS?.cross_section)
    const [fullExtendEvent, setFullExtendEvent] = useState(null)
    const mapObjects = useRef({
        tile: null,
        river: null,
        flow_path_left: null,
        flow_path_right: null,
        streamArrow: null,
        banks: [],
        banksLayer: null,
        mannings: [],
        manningsTexts: [],
        manningsLayer: null,
        manningsTextLayer: null,
        ineffs: [],
        ineffLayer: null,
        crossSections: [],
        crossSectionTexts: [],
        crossSectionLayer: null,
        crossSectionTextLayer: null,
        flowChanges: [],
        flowChangeLayer: null,
        downstreamBoundary: null,
        blockObst: [],
        blockObstLayer: null,
        structures: [],
        structureLayer: null,
        structureTexts: [],
        structureTextLayer: null,
        multipleOpeningLines: [],
        multipleOpeningLinesLayer: null,
        floodExtends: [],
        floodExtendsLayer: null,
        referenceLayers: [],
        projectLayers: [],
        drawControl: null,
        plugins: [],
        searchLayer: null,
        textLayer: null,
        loadLayerTimeout: null,
        layerSelectRoot: null,
        layerSelectControl: null,
        projectionSelectRoot: null,
        projectionSelectControl: null
    })

    const handleResize = () => {
        setSize({
            width: window.innerWidth-32,
            height: window.innerHeight-125,
        })
    }

    const fullExtend = async (e) => {
        try {
            const data = await ShapeFileHelper.getBounding(riverBoundingCoords, mapContext[type]?.bounding)

            map?.fitBounds([
                data[1],
                data[3],
            ])
        }
        catch (exp) {
            console.log(exp)
        }
    }

    const getColor = (csName, type, defColor) => {
        if(filter) {
            const inFilter = HecRasHelper.inFilter({us: filter?.us, ds: filter?.ds, cs_name: csName})
            if(type === 'text' && inFilter) {
                return '#00a8ff'
            }
            if(type === 'cross_section' && inFilter) {
                return '#00a8ff'
            }
            if(type === 'structure' && inFilter) {
                return '#00a8ff'
            }
        }

        return defColor
    }

    const loadPlugins = () => {
        if(mapObjects.current.plugins.length > 0) {
            return
        }

        window.guideLayers = []
        // Use effective projection (project if available, otherwise user preference)
        const projText = activeProjection?.text || projection
        const projName = activeProjection?.name || 'Unknown'
        const isProjectProjection = activeProjection?.isProject || false
        mouseCoordRef.current = MouseCoord(L, projText, proj4, map, projName)
        mouseCoordRef.current.updateProjection(projText, projName, isProjectProjection)
        MapProjectInfo(L, type, map)
        FullExtend(L, type)
        KML(L)

        MeasureTool(L, map)
        const Ruler = L.Control.LinearMeasurement.extend({
            layerSelected: function(e){}
        });
        mapObjects.current.plugins.push(map.addControl(new Ruler({
            unitSystem: 'imperial',
            color: '#04d9ff',
            show_azimut: false,
            position: controlPosition
        })))

        map.removeControl(map.zoomControl);
        mapObjects.current.plugins.push(L.control.fullExtend({position: controlPosition}).addTo(map));

        map.on(L.Draw.Event.CREATED, function (e) {

        });

        const ss = new SimpleMapScreenshoter({preventDownload: true, position: controlPosition}).addTo(map)
        mapObjects.current.plugins.push(ss)
        const ssInterval = setInterval(() => {
            const ssButton = document.getElementsByClassName('leaflet-control-simpleMapScreenshoter-btn')[0]
            if(ssButton) {
                ssButton.onclick = (e) => {
                    ss.takeScreen('blob', {
                        mimeType: 'image/png'
                    }).then(async blob => {
                        await navigator.clipboard.write([
                            new window.ClipboardItem({ "image/png": blob })
                        ]);

                        notification.success({
                            message: 'Image is copied to clipboard!'
                        })
                    })
                }

                clearInterval(ssInterval)
            }
        }, 100)

        // LayerSelect Control - Leaflet Control olarak ekleniyor
        const LayerSelectControl = L.Control.extend({
            options: {
                position: controlPosition
            },
            onAdd: function(leafletMap) {
                const container = L.DomUtil.create('div');
                
                L.DomEvent.disableClickPropagation(container);
                L.DomEvent.disableScrollPropagation(container);
                
                mapObjects.current.layerSelectRoot = createRoot(container);
                mapObjects.current.layerSelectRoot.render(
                    <LayerSelectLeaflet
                        type={type}
                        projectLayers={projectLayers}
                        onProjectLayerChange={onProjectLayerChange}
                        riverBounding={riverBoundingCoords}
                        mapContext={mapContext}
                        dispatchProject={dispatchProject}
                        ShapeTableComponent={ShapeTable}
                        openModal={openModal}
                        userSettings={user?.settings}
                        user={user}
                        setSettings={setSettings}
                        isSideBySide={isSideBySide}
                    />
                );
                
                return container;
            },
            onRemove: function(leafletMap) {
                if (mapObjects.current.layerSelectRoot) {
                    const root = mapObjects.current.layerSelectRoot;
                    mapObjects.current.layerSelectRoot = null;
                    setTimeout(() => root.unmount(), 0);
                }
            }
        });
        mapObjects.current.layerSelectControl = new LayerSelectControl().addTo(map);

        // ProjectionSelect Control - Projeksiyon değiştirme için
        const ProjectionSelectControl = L.Control.extend({
            options: {
                position: 'bottomleft'
            },
            onAdd: function(leafletMap) {
                const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control');
                
                L.DomEvent.disableClickPropagation(container);
                L.DomEvent.disableScrollPropagation(container);
                
                mapObjects.current.projectionSelectRoot = createRoot(container);
                mapObjects.current.projectionSelectRoot.render(
                    <ProjectionSelect
                        projectProjection={projection}
                        activeProjection={activeProjection}
                        onProjectionChange={setActiveProjection}
                        userPreference={userPreferenceProjection}
                    />
                );
                
                return container;
            },
            onRemove: function(leafletMap) {
                if (mapObjects.current.projectionSelectRoot) {
                    const root = mapObjects.current.projectionSelectRoot;
                    mapObjects.current.projectionSelectRoot = null;
                    setTimeout(() => root.unmount(), 0);
                }
            }
        });
        mapObjects.current.projectionSelectControl = new ProjectionSelectControl().addTo(map);

        // MapTypeSwitch Control - Base/Compare/SideBySide geçişi için
        if(onTypeChange) {
            const MapTypeSwitchControl = L.Control.extend({
                options: {
                    position: controlPosition
                },
                onAdd: function(leafletMap) {
                    const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control');
                    
                    L.DomEvent.disableClickPropagation(container);
                    L.DomEvent.disableScrollPropagation(container);
                    
                    mapObjects.current.mapTypeSwitchRoot = createRoot(container);
                    mapObjects.current.mapTypeSwitchRoot.render(
                        <MapTypeSwitchButton 
                            currentType={buttonType} 
                            onTypeChange={onTypeChange} 
                            hasCompareData={hasCompareData}
                        />
                    );
                    
                    return container;
                },
                onRemove: function(leafletMap) {
                    if (mapObjects.current.mapTypeSwitchRoot) {
                        const root = mapObjects.current.mapTypeSwitchRoot;
                        mapObjects.current.mapTypeSwitchRoot = null;
                        setTimeout(() => root.unmount(), 0);
                    }
                }
            });
            mapObjects.current.mapTypeSwitchControl = new MapTypeSwitchControl().addTo(map);
        }
    }

    const onChangeLayers = async () => {
        if(!map)
            return

        try {
            await loadReferenceLayers()
            let time = 0;

            const _interval = setInterval(() => {
                time++;
                if(document.getElementById('layer-load-info'))
                    document.getElementById('layer-load-info').innerText = `Please wait, Layer is loading... (${time} sec)`
            }, 1000)

            loadProjectLayers().then(x => {
                clearInterval(_interval)
            })

            if(window.bounding) {
                map.removeLayer(window.bounding)
            }

            if(mapContext[type]?.bounding?.showBounding)
            {
                window.bounding = L.polygon(await ShapeFileHelper.getBounding(riverBoundingCoords, mapContext[type]?.bounding), { color: 'gray' }).addTo(map);

            }
        }
        catch (exp) {
            console.log(exp)
        }
    }

    const onLayerSearch = (item) => {
        if(item.type === 'cross_section') {
            dispatchProject({
                type: AppActions.SET_SELECTED_RS,
                data: {rs: item._text}
            })
        }
    }

    const loadToolbar = () => {
        // Skip toolbar in side-by-side mode
        if (isSideBySide) return
        
        dispatchProject({
            type: AppActions.SET_MESSAGE_TOOLBAR_ITEM,
            data: {
                toolbar: (
                    <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                        <TileSelect value={tile} onChange={setTile} tiles={getTiles()}/>
                        <ProfileSelect profiles={mapData?.profiles} onChangeProfile={setProfile} selectedProfile={profile} />
                        <Space.Compact size={'small'}>
                            <LayerSearch onChange={onLayerSearch} type={type}/>
                        </Space.Compact>
                    </div>
                )
            }
        })
    }

    const loadReferenceLayers = async () => {
        // Recursive bringToBack helper
        const bringLayerToBack = (layer) => {
            if(layer.eachLayer) {
                layer.eachLayer(bringLayerToBack);
            }
            if(layer.bringToBack) {
                layer.bringToBack();
            }
        };
        
        const _refLayers = mapContext[type].referenceLayers.filter(x => {
            const layer = mapContext[type].selectedLayers.reference.find(y => y.name === x.name)
            if(!layer && x?.layerObject?.remove) {
                x.layerObject.remove()
                return false
            }
            else {
                if(!map.hasLayer(x.layerObject)) {
                    map.addLayer(x.layerObject)
                    // Reference layer'ı en alta gönder (recursive)
                    bringLayerToBack(x.layerObject);
                }
            }

            return true
        })

        for (const x of mapContext[type].selectedLayers.reference) {
            const layer = mapContext[type].referenceLayers.find(y => y.name === x.name)
            if(!layer) {
                try {
                    let track;

                    // Handle ArcGIS Feature Service (Vector/GeoJSON) - loads ONCE with bounding box
                    if (x.type === 'arcgis-feature') {
                        // Get bounding box from Bounding Settings (same as Show/Hide Bounding)
                        let bbox = null;
                        try {
                            const boundingCoords = await ShapeFileHelper.getBounding(riverBoundingCoords, mapContext[type]?.bounding);
                            console.log('FEMA Vector - Bounding coords:', boundingCoords);
                            if (boundingCoords && boundingCoords.length >= 4) {
                                // boundingCoords format: [[lat1,lng1], [lat2,lng2], [lat3,lng3], [lat4,lng4]]
                                const lats = boundingCoords.map(c => c[0]);
                                const lngs = boundingCoords.map(c => c[1]);
                                const minLat = Math.min(...lats);
                                const maxLat = Math.max(...lats);
                                const minLng = Math.min(...lngs);
                                const maxLng = Math.max(...lngs);
                                bbox = `${minLng},${minLat},${maxLng},${maxLat}`;
                                console.log('FEMA Vector - Using bbox:', bbox);
                            }
                        } catch (e) {
                            console.warn('Could not get bounding from settings:', e);
                        }
                        
                        // If no bounding available, don't load - show error
                        if (!bbox) {
                            notification.error({
                                message: 'Cannot load FEMA data',
                                description: 'No bounding box available. Please load a project first.'
                            });
                            track = L.layerGroup();
                            continue;
                        }
                        
                        // Split bounding box into smaller grid cells to avoid API limits
                        const [bboxXmin, bboxYmin, bboxXmax, bboxYmax] = bbox.split(',').map(c => parseFloat(c));
                        
                        // Max cell size in degrees (approx 0.05 deg = ~5km)
                        const MAX_CELL_SIZE = 0.05;
                        
                        // Calculate grid dimensions
                        const width = bboxXmax - bboxXmin;
                        const height = bboxYmax - bboxYmin;
                        const numCols = Math.ceil(width / MAX_CELL_SIZE);
                        const numRows = Math.ceil(height / MAX_CELL_SIZE);
                        const cellWidth = width / numCols;
                        const cellHeight = height / numRows;
                        
                        const totalCells = numCols * numRows;
                        console.log(`FEMA: Splitting bbox into ${numCols}x${numRows} = ${totalCells} cells`);
                        
                        // Show modal once with initial state
                        setFemaProgress({ current: 0, total: totalCells, numCols, numRows, features: 0, errors: 0 });
                        
                        // Helper: Convert ESRI JSON to GeoJSON
                        const esriToGeoJSON = (esriData) => {
                            if (!esriData.features) return { type: 'FeatureCollection', features: [] };
                            
                            const features = esriData.features.map(f => {
                                let geometry = null;
                                if (f.geometry) {
                                    if (f.geometry.rings) {
                                        geometry = { type: 'Polygon', coordinates: f.geometry.rings };
                                    } else if (f.geometry.paths) {
                                        geometry = { type: 'LineString', coordinates: f.geometry.paths[0] };
                                    } else if (f.geometry.x !== undefined) {
                                        geometry = { type: 'Point', coordinates: [f.geometry.x, f.geometry.y] };
                                    }
                                }
                                return {
                                    type: 'Feature',
                                    geometry: geometry,
                                    properties: f.attributes || {}
                                };
                            });
                            
                            return { type: 'FeatureCollection', features };
                        };
                        
                        // Build grid cells and fetch each
                        const allFeatures = [];
                        const featureIds = new Set(); // To avoid duplicates
                        let successCount = 0;
                        let errorCount = 0;
                        
                        try {
                            let cellIndex = 0;
                            for (let row = 0; row < numRows; row++) {
                                for (let col = 0; col < numCols; col++) {
                                    cellIndex++;
                                    const cellXmin = (bboxXmin + col * cellWidth).toFixed(4);
                                    const cellYmin = (bboxYmin + row * cellHeight).toFixed(4);
                                    const cellXmax = (bboxXmin + (col + 1) * cellWidth).toFixed(4);
                                    const cellYmax = (bboxYmin + (row + 1) * cellHeight).toFixed(4);
                                    
                                    const queryUrl = `${x.url}/query?where=1%3D1&geometryType=esriGeometryEnvelope&geometry=${cellXmin}%2C${cellYmin}%2C${cellXmax}%2C${cellYmax}&inSR=4326&outSR=4326&spatialRel=esriSpatialRelIntersects&outFields=${encodeURIComponent(x.options?.outFields || '*')}&returnGeometry=true&f=json`;
                                    
                                    try {
                                        const response = await fetch(queryUrl);
                                        const esriData = await response.json();
                                        
                                        if (esriData.features && esriData.features.length > 0) {
                                            const geojson = esriToGeoJSON(esriData);
                                            // Add unique features only (avoid duplicates at cell boundaries)
                                            geojson.features.forEach(f => {
                                                const fid = f.properties?.OBJECTID || JSON.stringify(f.geometry?.coordinates?.[0]?.[0]);
                                                if (!featureIds.has(fid)) {
                                                    featureIds.add(fid);
                                                    allFeatures.push(f);
                                                }
                                            });
                                            successCount++;
                                        } else if (!esriData.error) {
                                            successCount++;
                                        } else {
                                            console.warn(`FEMA cell [${row},${col}] error:`, esriData.error?.message);
                                            errorCount++;
                                        }
                                    } catch (cellError) {
                                        console.warn(`FEMA cell [${row},${col}] fetch error:`, cellError);
                                        errorCount++;
                                    }
                                    
                                    // Update progress after each cell
                                    setFemaProgress(prev => ({
                                        ...prev,
                                        current: cellIndex,
                                        features: allFeatures.length,
                                        errors: errorCount
                                    }));
                                }
                            }
                            
                            console.log(`FEMA: Loaded ${allFeatures.length} unique features from ${successCount} cells (${errorCount} errors)`);
                            
                            if (allFeatures.length > 0) {
                                const geojsonData = { type: 'FeatureCollection', features: allFeatures };
                                const styleColors = x.options?.style?.colors || {};
                                const subtypeStyles = x.options?.style?.subtypeStyles || {};
                                
                                track = L.geoJSON(geojsonData, {
                                    style: (feature) => {
                                        const zone = feature.properties?.FLD_ZONE || 'default';
                                        const subtype = (feature.properties?.ZONE_SUBTY || '').trim();
                                        
                                        // Hide AREA OF MINIMAL FLOOD HAZARD polygons
                                        if (subtype.toUpperCase().includes('AREA OF MINIMAL FLOOD HAZARD')) {
                                            return {
                                                color: 'transparent',
                                                fillColor: 'transparent',
                                                weight: 0,
                                                opacity: 0,
                                                fillOpacity: 0
                                            };
                                        }
                                        
                                        // Check for subtype-specific styling first
                                        let styleOverride = null;
                                        if (subtype && subtype !== '<Null>') {
                                            // Check exact match first
                                            if (subtypeStyles[subtype]) {
                                                styleOverride = subtypeStyles[subtype];
                                            } else {
                                                // Check partial matches
                                                for (const key of Object.keys(subtypeStyles)) {
                                                    // Check if subtype contains the key or vice versa
                                                    if (subtype.toUpperCase().includes(key.toUpperCase())) {
                                                        styleOverride = subtypeStyles[key];
                                                        break;
                                                    }
                                                }
                                            }
                                        }
                                        
                                        if (styleOverride) {
                                            return {
                                                color: styleOverride.color || styleOverride.fillColor,
                                                fillColor: styleOverride.fillColor || styleOverride.color,
                                                weight: x.options?.style?.weight || 1,
                                                opacity: x.options?.style?.opacity || 0.8,
                                                fillOpacity: styleOverride.fillOpacity ?? x.options?.style?.fillOpacity ?? 0.5,
                                                // Add dashArray for diagonal pattern simulation
                                                dashArray: styleOverride.pattern === 'diagonal' ? '5, 5' : null
                                            };
                                        }
                                        
                                        const color = styleColors[zone] || styleColors['default'] || '#808080';
                                        return {
                                            color: color,
                                            fillColor: color,
                                            weight: x.options?.style?.weight || 1,
                                            opacity: x.options?.style?.opacity || 0.8,
                                            fillOpacity: x.options?.style?.fillOpacity || 0.5
                                        };
                                    },
                                    onEachFeature: (feature, layer) => {
                                        layer.on('mouseover', function(e) {
                                            const props = feature.properties || {};
                                            const zone = props.FLD_ZONE || 'N/A';
                                            const subtype = props.ZONE_SUBTY || '';
                                            // -9999 is FEMA's null/no-data value
                                            const bfe = (props.STATIC_BFE && props.STATIC_BFE !== -9999) ? `BFE: ${props.STATIC_BFE} ft` : '';
                                            const tooltip = `Zone: ${zone} ${subtype}\n${bfe}`.trim();
                                            layer.bindTooltip(tooltip, {sticky: true}).openTooltip();
                                        });
                                        
                                        layer.on('click', function(e) {
                                            L.DomEvent.stopPropagation(e);
                                            createLeafletPopup({
                                                L,
                                                content: (<ShapeItem feature={feature} />),
                                                contentStyle: { maxHeight: 380, overflowY: 'auto' },
                                                properties: {autoPan: true},
                                                latlng: e.latlng,
                                                map
                                            });
                                        });
                                    }
                                });
                                
                                notification.success({
                                    message: `FEMA NFHL loaded`,
                                    description: `${allFeatures.length} flood zone features from ${numCols * numRows} grid cells`
                                });
                                setFemaProgress(null);
                            } else {
                                notification.warning({
                                    message: 'No FEMA data',
                                    description: 'No flood zones found in this area'
                                });
                                track = L.layerGroup();
                                setFemaProgress(null);
                            }
                        } catch (fetchError) {
                            console.error('FEMA Feature Service error:', fetchError);
                            notification.error({
                                message: 'FEMA load failed',
                                description: 'Could not load flood zone data'
                            });
                            track = L.layerGroup();
                            setFemaProgress(null);
                        }
                    }
                    // Handle WMS layers (unbounded - full map)
                    else if (x.type === 'wms') {
                        openModal({
                            title: 'Layer is loading...',
                            component: (<Spin spinning={true} />),
                            closable: false
                        });
                        track = L.tileLayer.wms(x.url, {
                            layers: x.layers,
                            format: x.options?.format || 'image/png',
                            transparent: x.options?.transparent !== false,
                            version: x.options?.version || '1.1.1',
                            attribution: x.options?.attribution || '',
                            opacity: 0.7
                        });
                    }
                    // Handle WMS layers with bounding box limit
                    else if (x.type === 'wms-bounded') {
                        openModal({
                            title: 'Layer is loading...',
                            component: (<Spin spinning={true} />),
                            closable: false
                        });
                        // Get bounding box from Bounding Settings
                        let wmsBounds = null;
                        try {
                            const boundingCoords = await ShapeFileHelper.getBounding(riverBoundingCoords, mapContext[type]?.bounding);
                            if (boundingCoords && boundingCoords.length >= 4) {
                                const lats = boundingCoords.map(c => c[0]);
                                const lngs = boundingCoords.map(c => c[1]);
                                const minLat = Math.min(...lats);
                                const maxLat = Math.max(...lats);
                                const minLng = Math.min(...lngs);
                                const maxLng = Math.max(...lngs);
                                wmsBounds = L.latLngBounds(
                                    L.latLng(minLat, minLng),
                                    L.latLng(maxLat, maxLng)
                                );
                            }
                        } catch (e) {
                            console.warn('Could not get bounding for WMS:', e);
                        }
                        
                        if (!wmsBounds) {
                            notification.error({
                                message: 'Cannot load FEMA layer',
                                description: 'No bounding box available. Please load a project first.'
                            });
                            track = L.layerGroup();
                        } else if (x.options?.isArcGIS) {
                            // ArcGIS REST Export - create image overlay
                            const sw = wmsBounds.getSouthWest();
                            const ne = wmsBounds.getNorthEast();
                            const bboxStr = `${sw.lng},${sw.lat},${ne.lng},${ne.lat}`;
                            
                            // Calculate image size based on bounds (reasonable size)
                            const aspectRatio = (ne.lng - sw.lng) / (ne.lat - sw.lat);
                            const height = 1024;
                            const width = Math.round(height * aspectRatio);
                            
                            // Use base URL from config, append export parameters
                            // Use layerDefs to show only flood zones, dpi=96 for better quality
                            const baseUrl = x.url.replace(/\/export\/?$/, '');
                            const exportUrl = `${baseUrl}/export?bbox=${bboxStr}&bboxSR=4326&imageSR=3857&layers=show:${x.layers}&layerDefs=&size=${width},${height}&format=${x.options?.format || 'png32'}&transparent=true&dpi=96&f=image`;
                            
                            console.log('ArcGIS Export URL:', exportUrl);
                            
                            track = L.imageOverlay(exportUrl, wmsBounds, {
                                opacity: 0.7,
                                attribution: x.options?.attribution || ''
                            });
                            
                            // Handle load errors
                            track.on('error', (error) => {
                                console.error('ArcGIS Export Error:', error);
                                notification.error({
                                    message: 'FEMA layer load failed',
                                    description: 'Could not load flood zone image'
                                });
                            });
                        } else {
                            // Standard WMS
                            const wmsOptions = {
                                layers: x.layers,
                                format: x.options?.format || 'image/png',
                                transparent: x.options?.transparent !== false,
                                version: x.options?.version || '1.1.1',
                                attribution: x.options?.attribution || '',
                                opacity: 0.7,
                                bounds: wmsBounds
                            };
                            // Add CRS if specified (convert string to L.CRS)
                            if (x.options?.crs) {
                                const crsMap = {
                                    'EPSG4326': L.CRS.EPSG4326,
                                    'EPSG3857': L.CRS.EPSG3857,
                                    'EPSG3395': L.CRS.EPSG3395
                                };
                                wmsOptions.crs = crsMap[x.options.crs] || L.CRS.EPSG3857;
                            }
                            console.log('WMS Options:', wmsOptions, 'URL:', x.url);
                            track = L.tileLayer.wms(x.url, wmsOptions);
                            
                            // Add error handler
                            track.on('tileerror', (error) => {
                                console.error('WMS Tile Error:', error);
                            });
                        }
                    }
                    // Handle KML layers (default - existing functionality)
                    else if (x.file) {
                        openModal({
                            title: 'Layer is loading...',
                            component: (<Spin spinning={true} />),
                            closable: false
                        });
                        const res = await fetch(`/shapes/${x.file}`);
                        const kmlText = await res.text()

                        const parser = new DOMParser();
                        const kml = parser.parseFromString(kmlText, 'text/xml');
                        track = new window.L.KML(kml);
                        
                        // Recursive olarak tüm layer'lara stil ve event ekle
                        const processLayer = (layer) => {
                            // İç içe layer group varsa recursive işle
                            if(layer.eachLayer) {
                                layer.eachLayer(processLayer);
                            }
                            
                            // Mavi stil uygula
                            if(layer.setStyle) {
                                layer.setStyle({
                                    color: '#0066ff',
                                    fillColor: '#3399ff',
                                    fillOpacity: 0.3,
                                    weight: 2
                                });
                            }
                            
                            // Eski popup ve tooltip'i kaldır
                            if(layer.unbindPopup) {
                                layer.unbindPopup();
                            }
                            if(layer.unbindTooltip) {
                                layer.unbindTooltip();
                            }
                            
                            // Eski event listener'ları temizle
                            layer.off('click');
                            layer.off('mouseover');
                            
                            // Feature yoksa atla
                            if(!layer.feature?.properties) {
                                return;
                            }
                            
                            // Tooltip - hover'da name göster (ShapeTooltip kullan)
                            layer.on('mouseover', function(e) {
                                const key = Object.keys(layer.feature.properties).find(k => layer.feature.properties[k]);
                                if(key) {
                                    let html = ReactDOMServer.renderToString(
                                        <ShapeTooltip
                                            labels={[key]}
                                            feature={layer.feature}
                                        />
                                    );
                                    layer.bindTooltip(L.tooltip({}).setContent(html), {sticky: true}).openTooltip();
                                }
                            });
                            
                            // Click'te createLeafletPopup ve ShapeItem kullan
                            layer.on('click', function(e) {
                                L.DomEvent.stopPropagation(e);
                                if(Object.keys(layer.feature.properties).length > 0) {
                                    const latlng = e.latlng;
                                    createLeafletPopup({
                                        L,
                                        content: (<ShapeItem feature={layer.feature} />),
                                        contentStyle: {
                                            maxHeight: 380,
                                            overflowY: 'auto'
                                        },
                                        properties: {autoPan: true},
                                        latlng,
                                        map
                                    });
                                }
                            });
                        };
                        
                        processLayer(track);
                    }
                    
                    _refLayers.push({
                        ...x,
                        layerObject: track
                    })
                    map.addLayer(track);
                    
                    // Reference layer'ları en alta gönder (recursive)
                    bringLayerToBack(track);
                }
                catch (exp) {
                    console.log(exp)
                }
                
                closeModal()
            }
        }

        dispatchProject({
            type: AppActions.SET_MAP_CONTEXT,
            data: {
                map: {
                    ...mapContext,
                    [type]: {
                        ...mapContext[type],
                        referenceLayers: [..._refLayers]
                    }
                }
            }
        })
    }

    function applyHillshade(georaster, row, col, zFactor = 1, azimuth = 315, altitude = 45) {
        const width = georaster.width;
        const height = georaster.height;

        // Çevre pikselleri kullanarak z değerlerini al
        const z1 = georaster.values[0][row - 1]?.[col - 1] * zFactor || 0;
        const z2 = georaster.values[0][row - 1]?.[col] * zFactor || 0;
        const z3 = georaster.values[0][row - 1]?.[col + 1] * zFactor || 0;
        const z4 = georaster.values[0][row]?.[col - 1] * zFactor || 0;
        const z5 = georaster.values[0][row]?.[col + 1] * zFactor || 0;
        const z6 = georaster.values[0][row + 1]?.[col - 1] * zFactor || 0;
        const z7 = georaster.values[0][row + 1]?.[col] * zFactor || 0;
        const z8 = georaster.values[0][row + 1]?.[col + 1] * zFactor || 0;

        // dz/dx ve dz/dy eğim hesaplaması (mutlak değer ile negatif pixelHeight sorununu çöz)
        const dzdx = ((z3 + 2 * z5 + z8) - (z1 + 2 * z4 + z6)) / (8 * Math.abs(georaster.pixelWidth));
        // pixelHeight negatif olabilir (kuzey-yukarı görüntülerde), bu yüzden işareti düzelt
        const signY = georaster.pixelHeight < 0 ? -1 : 1;
        const dzdy = signY * ((z6 + 2 * z7 + z8) - (z1 + 2 * z2 + z3)) / (8 * Math.abs(georaster.pixelHeight));

        // Eğimi ve aspect (açı) hesaplama
        const slope = Math.atan(Math.sqrt(dzdx * dzdx + dzdy * dzdy));
        const aspect = Math.atan2(dzdy, -dzdx);

        // Işık açısı ve aydınlanma hesaplaması
        const radians = (angle) => (angle * Math.PI) / 180;
        const zenith = radians(90 - altitude);
        const azimuthRad = radians(azimuth);

        // Hillshade hesaplama
        const shade = Math.cos(zenith) * Math.cos(slope) +
            Math.sin(zenith) * Math.sin(slope) * Math.cos(azimuthRad - aspect);

        return Math.max(0, Math.min(255, Math.round(255 * shade)));
    }

    function pixelValueToColor(elevationValue, minElevation, maxElevation) {
        const normalizedValue = (elevationValue - minElevation) / (maxElevation - minElevation);

        // Elevation color scale: High contrast version
        const colorScale = [
            [0, 100, 0, 255],      // Dark Green (lowest)
            [50, 205, 50, 255],    // Lime Green
            [173, 255, 47, 255],   // Green-Yellow
            [255, 255, 0, 255],    // Bright Yellow
            [255, 165, 0, 255],    // Bright Orange
            [255, 69, 0, 255],     // Orange-Red
            [255, 0, 0, 255],      // Pure Red
            [139, 0, 0, 255],      // Dark Red
            [75, 0, 30, 255],      // Very Dark Maroon (highest)
        ];

        const numColors = colorScale.length;
        const scaleStep = 1 / (numColors - 1);

        let r = 255, g = 255, b = 255;
        for (let i = 0; i < numColors - 1; i++) {
            const lowerBound = i * scaleStep;
            const upperBound = (i + 1) * scaleStep;

            if (normalizedValue >= lowerBound && normalizedValue <= upperBound) {
                const factor = (normalizedValue - lowerBound) / (upperBound - lowerBound);

                r = Math.round(colorScale[i][0] + factor * (colorScale[i + 1][0] - colorScale[i][0]));
                g = Math.round(colorScale[i][1] + factor * (colorScale[i + 1][1] - colorScale[i][1]));
                b = Math.round(colorScale[i][2] + factor * (colorScale[i + 1][2] - colorScale[i][2]));
                break;
            }
        }

        return [r, g, b];
    }

// Gölge efektini renge uygulama fonksiyonu
    function applyShadeToColor(color, shadeValue) {
        // Renk bileşenlerine hillshade uygula (gölge etkisi)
        const factor = shadeValue / 255;
        const r = Math.round(color[0] * factor);
        const g = Math.round(color[1] * factor);
        const b = Math.round(color[2] * factor);

        return [r,g,b];
    }


    const getHighlightColor = (feature, existObjectId) => {
        let color = '#ffff00';
        let highlight = false

        let key = 'OBJECTID'
        if(!existObjectId) {
            key = 'SURVPT_ID'
        }

        const props = feature?.properties || {}
        const point = highlightSurvey.find(x => x?.properties[key] === props[key])
        if(point) {
            color = 'lightblue'
            highlight = true
        }

        return {color, highlight}
    }

    const loadProjectLayers = async () => {
        if(!window.projectShapes) {
            window.projectShapes = {}
        }

        Object.keys(window.projectShapes).forEach(key => {
            if(window.projectShapes[key]?.remove){
                window.projectShapes[key].remove()
            }
        })

        // add layers
        for (const x of mapContext[type].selectedLayers.project) {
            const layerRow = projectLayers.find(y => y.id === x.id)
            if(layerRow) {
                // add
                try {
                    if(layerRow.ext?.toLowerCase() === 'geojson') {
                        const bounding = await ShapeFileHelper.getBounding(riverBoundingCoords, mapContext[type]?.bounding)
                        let layerData = {}
                        if(typeof layerRow.data === 'string') {
                            layerData = JSON.parse(layerRow.data)
                        }
                        else {
                            layerData = {...layerRow.data}
                        }

                        layerData = ShapeFileHelper.filterFeatures(layerData, layerRow.filters || {}, bounding)

                        const labelGroup = L.markerClusterGroup({
                            zoomToBoundsOnClick: true,
                            maxClusterRadius: (zoom) => {
                                return (zoom >= 25) ? 0 : 40
                            },
                            iconCreateFunction: function(cluster) {
                                const markers = cluster.getAllChildMarkers()
                                let pointColor = 'yellow';
                                for (const marker of markers) {
                                    const {color, highlight} = getHighlightColor(marker.feature, layerRow?.existObjectId)
                                    if(highlight) {
                                        pointColor = color
                                        break
                                    }
                                }

                                const count = cluster.getChildCount()
                                return L.divIcon({ html: `<div style="background-color: ${pointColor}; width: 24px; border-radius: 16px; border: 2px solid black; font-weight: bold; padding-left: 4px;">${count}</div>` });
                            }
                        });

                        labelGroup.addTo(map)
                        window.projectShapes[v4()] = labelGroup;
                        window.projectShapes[layerRow.id] = L.geoJSON(layerData, {
                            pointToLayer: function (feature, latlng) {
                                if(feature?.geometry?.type === 'Point') {
                                    const {color, highlight} = getHighlightColor(feature, layerRow?.existObjectId)

                                    const circleLayer = L.circleMarker(latlng, { // Daire oluşturuluyor
                                        radius: 5, // Dairenin yarıçapı
                                        color: 'black', // Dairenin kenar rengi
                                        fillColor: color, // Dairenin dolgu rengi
                                        fillOpacity: 1, // Dolgu opaklığı,
                                    });
                                    // const circleLayer = L.circle(latlng, 0.1, {color: 'black', fillColor: '#ffff00', fillOpacity: 0.5})
                                    circleLayer.bringToFront()
                                    return circleLayer
                                }
                            },
                            onEachFeature: (feature, layer) => {
                                layer.on('mouseover', function (e) {
                                    let key = Object.keys(feature.properties).find(x => x.toLowerCase().includes('id') && feature.properties[x])
                                    if(!key)
                                        key = Object.keys(feature.properties).find(x => feature.properties[x])

                                    let html = ReactDOMServer.renderToString(
                                        <ShapeTooltip
                                            labels={layerRow?.labels || [key]}
                                            feature={feature}
                                        />
                                    );

                                    layer.bindTooltip(L.tooltip({}).setContent(html), {sticky: true}).openTooltip();
                                });

                                layer.on('click', function (e) {
                                    const latlng = e.latlng;
                                    let html = ReactDOMServer.renderToString(
                                        <ShapeItem
                                            feature={feature}
                                        />
                                    );

                                    const content = `<div style="max-height: 380px; overflow-y: auto">${html}</div>`
                                    L.popup({autoPan: true})
                                        .setLatLng(latlng)
                                        .setContent(content)
                                        .openOn(map);
                                });
                            }
                        }).addTo(labelGroup)
                        labelGroup.bringToFront()
                    }
                    else if(layerRow.ext?.toLowerCase() === 'tif') {
                        const geo_data = await parseGeoraster(layerRow?.fileData)
                        layerRow.data = geo_data
                        const georaster = JSON.parse(JSON.stringify(layerRow.data))
                        const hillshade = applyHillshade(georaster)

                        let rows = 1
                        let columns = 1

                        const tifLayerColor = new GeoRasterLayer({
                            georaster: georaster,
                            opacity: mapContext[type]?.terrainLayers?.opacity_size,
                            pixelValuesToColorFn: (pixelValues) => {
                                if(columns === georaster.width) {
                                    rows++;
                                    columns = 1
                                }
                                else {
                                    columns++
                                }

                                const pixelValue = pixelValues[0];
                                if (pixelValue === 0)
                                    return null;

                                const hillshadeValue = applyHillshade(georaster, rows-1, columns-1);
                                const color = pixelValueToColor(pixelValue, georaster?.mins[0], georaster?.maxs[0]);
                                const [r,g,b]  = applyShadeToColor(color, hillshadeValue);
                                const hex = (1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1).toUpperCase();
                                return `#${hex}`;
                            },
                            resolution:  mapContext[type]?.terrainLayers?.resolution_size // optional parameter for adjusting display resolution
                        });

                        const hillshades = []
                        for(let r=0; r < georaster.height; r++) {
                            for(let c = 0 ; c < georaster.width; c++) {
                                hillshades.push(applyHillshade(
                                    georaster, 
                                    r, 
                                    c, 
                                    mapContext[type]?.terrainLayers?.gray_z_factor || 1,
                                    mapContext[type]?.terrainLayers?.azimuth || 315,
                                    mapContext[type]?.terrainLayers?.altitude || 45
                                ));
                            }
                        }


                        const canvas = document.createElement('canvas');
                        canvas.width = georaster.width;
                        canvas.height = georaster.height;
                        const ctx = canvas.getContext('2d');
                        const imageData = ctx.createImageData(georaster.width, georaster.height);

                        for (let i = 0; i < hillshades.length; i++) {
                            imageData.data[4 * i] = hillshades[i];
                            imageData.data[4 * i + 1] = hillshades[i];
                            imageData.data[4 * i + 2] = hillshades[i];
                            imageData.data[4 * i + 3] = 255 * (mapContext[type]?.terrainLayers?.gray_opacity_size);  // Opaklık (alpha)
                        }

                        ctx.putImageData(imageData, 0, 0);
                        const hillshadeUrl = canvas.toDataURL();

                        const tifLayerGray = L.imageOverlay(hillshadeUrl, tifLayerColor.getBounds(), {});

                        map.fitBounds(tifLayerGray.getBounds());
                        map.fitBounds(tifLayerColor.getBounds());


                        tifLayerGray.addTo(map);
                        tifLayerColor.addTo(map);

                        window.projectShapes[v4()] = tifLayerColor;
                        window.projectShapes[v4()] = tifLayerGray;
                    }
                }
                catch (exp) {
                    console.log(exp)
                }
            }
        }
    }

    const loadRiverStream = (zoomChanged) => {
        // zoom degistiginde butun riveri tekrar render etme
        if(mapObjects.current.river && !zoomChanged)
        {
            mapObjects.current.river.remove()
            mapObjects.current.river = null
        }

        if(modelLayers.includes('Flow Direction'))
        {
            // const freq = `${(mapContext[type]?.flowArrow?.freq / 3.28)}m` || '50m'
            const zoom = mapContext[type]?.zoom || 18
            const zoomSize = 25 - zoom
            const verticalDistance = getVerticalDistance()
            let freq_dist = verticalDistance / mapContext[type]?.flowArrow?.flow_count
            let freq = `${freq_dist < 100 ? 100 : freq_dist}m` || '500m'
            let size = `${mapContext[type]?.flowArrow?.flow_size + zoomSize}px` || '15px'

            if(zoomChanged && mapObjects.current.river) {
                mapObjects.current.river.arrowheads({frequency: freq, fill: false, size: size, color: '#04d9ff'}).addTo(map);
            }
            else {
                mapObjects.current.river = L.polyline(mapData.reach_xy, { color: 'blue' }).arrowheads({frequency: freq, fill: false, size: size, color: '#04d9ff'}).addTo(map);
            }
        }
        else {
            if(!zoomChanged) {
                mapObjects.current.river = L.polyline(mapData.reach_xy, { color: 'blue' }).addTo(map);
            }
        }
    }

    const setRS2MapCenter = async (zoom) => {
        let mapRS = mapData?.cross_sections?.find(x => x?.cross_section && parseFloat(x?.cross_section?.toString()) === parseFloat(selectedRS?.cross_section?.toString()))
        let xy = mapRS?.center

        if(!mapRS)
        {
            mapRS = mapData?.structures?.find(x => x?.cross_section && parseFloat(x?.cross_section?.toString()) === parseFloat(selectedRS?.cross_section?.toString()))

            xy = mapRS?.xy_list[0];
            if(mapRS?.xy_list[0]?.xy) {
                xy = mapRS?.xy_list[0]?.xy
            }
        }

        if(!xy) {
            await fullExtend()
            return
        }

        const center = getCenter(xy)
        map.setView(center, zoom)
    }

    const loadStructures = () => {
        if(mapObjects.current.structureLayer?.remove)
        {
            mapObjects.current.structureLayer.remove()
            mapObjects.current.structures = []
        }


        mapObjects.current.structureLayer = L.layerGroup()

        mapData?.structures?.forEach(cs => {
            cs?.xy_list?.forEach(item => {
                const xy = item.xy || []

                const isSelected = HecRasHelper.isCrossSectionMatch(
                    selectedRS?.cross_section,
                    cs.cross_section,
                    cs.cross_section_value
                );

                const polygon = L.polygon(xy || [], {
                    color: isSelected ? 'red' : getColor(cs.cross_section, 'structure', tile.structure),
                    fillColor: 'gray',
                    weight: 5
                }).addTo(mapObjects.current.structureLayer)
                polygon.cross_section = cs.cross_section
                polygon.search = cs.cross_section
                mapObjects.current.structures.push(polygon)
            })
        })

        mapObjects?.current?.structureLayer?.addTo(map)
        mapObjects?.current?.structures?.forEach(x => x.bringToBack())
    }

    const loadMultipleOpeningLines = () => {
        if(mapObjects.current.multipleOpeningLinesLayer?.remove)
        {
            mapObjects.current.multipleOpeningLinesLayer.remove()
            mapObjects.current.multipleOpeningLines = []
        }

        if(!modelLayers.includes('Multiple Opening'))
            return;

        mapObjects.current.multipleOpeningLinesLayer = L.layerGroup()

        mapData?.multiple_openings?.forEach(opening => {
            opening?.opening_xy_list?.forEach(xy => {
                mapObjects.current.multipleOpeningLines.push(L.polyline(xy || [], { color: 'red', weight: 1, dashArray: '3, 3', dashOffset: '5' }).addTo(mapObjects.current.multipleOpeningLinesLayer))
            })
        })

        mapObjects.current.multipleOpeningLinesLayer.addTo(map)
    }

    const loadFlowPaths = (profile) => {
        if(mapObjects.current.flow_path_left?.remove)
        {
            mapObjects.current.flow_path_left.remove()
            mapObjects.current.flow_path_left = null
        }

        if(mapObjects.current.flow_path_right?.remove)
        {
            mapObjects.current.flow_path_right.remove()
            mapObjects.current.flow_path_right = null
        }

        if(!modelLayers.includes('Flow Path'))
            return;

        const item = mapData?.flow_paths?.find(x => x.profile === profile?.target)
        if(!item)
            return;


        mapObjects.current.flow_path_left = L.polyline(item?.left_coords || [], { color: '#33CCFF', weight: 1 }).addTo(map);
        mapObjects.current.flow_path_right = L.polyline(item?.right_coords || [], { color: '#33CCFF', weight: 1 }).addTo(map);
    }

    const loadFloodExtends = (profile) => {
        if(mapObjects.current.floodExtendsLayer?.remove)
        {
            mapObjects.current.floodExtendsLayer.remove()
            mapObjects.current.floodExtends = []
        }

        if(!modelLayers.includes('Flood Extent'))
            return;

        mapObjects.current.floodExtendsLayer = L.layerGroup()

        const floodExtends = _.groupBy(mapData?.flood_extends, (x) => x.profile)
        Object.keys(floodExtends)?.forEach(key => {
            if(profile?.target === key) {
                floodExtends[key].forEach(item => {
                    mapObjects.current.floodExtends.push(L.polyline(item?.xy || [], { color: 'blue', weight: 2, }).addTo(mapObjects.current.floodExtendsLayer))
                })
            }
        })

        mapObjects.current.floodExtendsLayer.addTo(map)
    }

    const loadBlockObstr = () => {
        if(mapObjects.current.blockObstLayer?.remove)
        {
            mapObjects.current.blockObstLayer.remove()
            mapObjects.current.blockObst = []
        }

        if(!modelLayers.includes('Blocked Obstruction'))
            return;

        mapObjects.current.blockObstLayer = L.layerGroup()

        mapData?.cross_sections?.forEach(cs => {
            if(cs.type === 'cross_section') {
                if(cs?.block_obstr?.length > 0) {
                    for (const blockObstr of cs.block_obstr) {
                        mapObjects.current.blockObst.push(L.polyline(blockObstr, { color: 'black', weight: 2, }).addTo(mapObjects.current.blockObstLayer))
                    }
                }
            }
        })

        mapObjects.current.blockObstLayer.addTo(map)
    }

    const getSquareFromCenter = (center, R) => {
        const centerLat = center[0]
        const centerLng = center[1]
        const correction_factor = Math.cos(centerLat * Math.PI / 180);

        const topLat = centerLat + (R / 111139);
        const bottomLat = centerLat - (R / 111139);
        const leftLng = centerLng - (R / (111139 * correction_factor));
        const rightLng = centerLng + (R / (111139 * correction_factor));

        const square = {
            top_left: { lat: topLat, lng: leftLng },
            top_right: { lat: topLat, lng: rightLng },
            bottom_left: { lat: bottomLat, lng: leftLng },
            bottom_right: { lat: bottomLat, lng: rightLng }
        };

        return [square.top_left, square.top_right, square.bottom_right, square.bottom_left]
    }

    const loadBoundaryTable = () => {
        if(mapObjects.current.downstreamBoundary?.remove)
        {
            mapObjects.current.downstreamBoundary.remove()
        }

        if(!modelLayers.includes('Boundary Condition'))
            return;

        const boundary = mapData?.boundary
        if(boundary) {
            if(boundary?.chords?.length < 1)
                return;

            let R = (getVerticalDistance()/40)
            R = R*mapContext[type]?.flowArrow?.boundary_size/100

            const square_coords = getSquareFromCenter(boundary?.chords[0], R)
            const square = L.polygon(square_coords, {
                color: '#04d9ff',     // Çokgenin kenar rengi
                fillColor: '#f00', // Çokgenin iç dolgu rengi
                fillOpacity: 0.0,   // Çokgenin iç dolgu opaklığı
                weight: 5
            })

            mapObjects.current.downstreamBoundary = square.on('click', (e) => {
                const latlng = e.latlng;
                createLeafletPopup({
                    L,
                    content: (<BoundaryTable data={boundary?.data} />),
                    contentStyle: {
                        maxHeight: 600,
                        overflowY: 'auto'
                    },
                    properties: {autoPan: true, minWidth: HecRasHelper.getWidth(40)},
                    latlng,
                    map
                })
            })

            mapObjects.current.downstreamBoundary.addTo(map)
        }
    }

    const getVerticalDistance = () => {
        const northBound = map.getBounds().getNorth();
        const southBound = map.getBounds().getSouth();
        return L.latLng(northBound, 0).distanceTo(L.latLng(southBound, 0));
    }

    const loadFlowChangeTable = () => {
        if(mapObjects.current.flowChangeLayer?.remove)
        {
            mapObjects.current.flowChangeLayer.remove()
            mapObjects.current.flowChanges = []
        }

        if(!modelLayers.includes('Flow Change Location'))
            return;

        // Haritanın kuzey ve güney sınırlarını alın
        const vDist = getVerticalDistance()

        mapObjects.current.flowChangeLayer = L.layerGroup()
        mapData?.flow_change_locations?.forEach(fl => {
            if(fl?.chords?.length < 1)
                return;

            const circle = L.circle(fl?.chords[0], {
                color: '#04d9ff',      // Çemberin kenar rengi
                fillColor: '#f03', // Çemberin iç dolgu rengi
                fillOpacity: 0.0,  // Çemberin iç dolgu opaklığı
                radius: ((vDist/20)/4)*mapContext[type]?.flowArrow?.flow_change_size/50,
                weight: 5
            })

            circle.on('click', (e) => {
                const latlng = e.latlng;
                createLeafletPopup({
                    L,
                    content: (<FlowChangeTable data={mapData?.flow_change_locations || []} profiles={mapData?.profiles?.map(x => x.targetName)} selectedCS={fl?.cross_section} />),
                    contentStyle: {
                        maxHeight: 600,
                        overflowY: 'auto'
                    },
                    properties: {autoPan: true, minWidth: HecRasHelper.getWidth(17+mapData?.profiles?.length*10)},
                    latlng,
                    map
                })
            })

            circle.addTo(mapObjects.current.flowChangeLayer)
        })
        mapObjects.current.flowChangeLayer.addTo(map)
    }

    const loadTexts = () => {
        if(mapObjects.current.textLayer?.remove)
        {
            mapObjects.current.textLayer.remove()
            mapObjects.current.crossSectionTexts = []
            mapObjects.current.structureTexts = []
        }

        // mapObjects.current.textLayer = L.inflatableMarkersGroup({
        //     iconCreateFunction: function (icon) {return L.divIcon({html: `<div style="color: ${tile.textColor}"></div>`, iconSize: [0,0]});}
        // }).addTo(map);

        mapObjects.current.textLayer = L.markerClusterGroup({
            zoomToBoundsOnClick: true,
            iconCreateFunction: function(cluster) {
                return L.divIcon({ html: cluster.getAllChildMarkers()[0]?.options?.icon?.options?.html, className: 'dummy',});
            }
        }).addTo(map);

        mapData?.cross_sections?.forEach(cs => {
            let cs_text = `<div style="color: ${getColor(cs?.cross_section, 'text', tile.textColor)}">${cs?.cross_section}</div>`
            if(cs?.ratio && parseFloat(cs?.ratio?.toFixed(2)) !== 1) {
                let color = 'red'
                let skew_r = (1/Math.cos(parseFloat(cs?.skew) * Math.PI / 180)).toPrecision(3)
                if(skew_r === parseFloat(cs?.ratio).toPrecision(3)) {
                    color = 'green'
                }

                cs_text = `<div style="color: ${getColor(cs?.cross_section, 'text', tile.textColor)}">${cs?.cross_section}<br/><div style="color: ${color};">r=${cs.ratio?.toFixed(2)}</div></div>`
            }

            const text = L.divIcon({
                className: 'dummy',
                html: cs_text,
                iconSize: [100, 30], // Metnin boyutu
            })

            const marker = L.marker(cs.xy[0], {icon: text}).addTo(mapObjects.current.textLayer);
            marker.cross_section = cs.cross_section
            marker.on('click', (e) => {
                const latlng = e.latlng;
                createLeafletPopup({
                    L,
                    content: (<CrossSectionWindow riverStation={{base_ui_data: cs?.cs_ui, base_title: cs?.cross_section}} />),
                    contentStyle: {
                        maxHeight: 800,
                        overflowY: 'auto'
                    },
                    properties: {autoPan: true, maxWidth: 760},
                    latlng,
                    map
                })
            })
            mapObjects.current.crossSectionTexts.push(marker)
        })

        mapData?.structures?.forEach(cs => {
            cs?.xy_list?.forEach(item => {
                const xy = item.xy || []

                const str_center_x = (xy?.map(x => x[0]).reduce((a, b) => a + b))/xy?.length
                const str_center_y = (xy?.map(x => x[1]).reduce((a, b) => a + b))/xy?.length

                const text_marker = L.marker([str_center_x, str_center_y], {
                    icon: L.divIcon({
                        className: 'dummy',
                        html: ReactDOMServer.renderToString(<StructureName textColor={getColor(cs?.cross_section, 'text', tile.textColor)} selectedRS={selectedRS?.cross_section} cs={cs} strItem={item} />), // Buraya istediğiniz metni ekleyin
                        iconSize: [100, 30], // Metnin boyutu
                    }),
                    search: cs.cross_section
                }).addTo(mapObjects.current.textLayer)
                text_marker.cs_data = cs
                text_marker.on('click', (e) => {
                    const latlng = e.latlng;
                    let content = ``
                    if(cs.typeName === 'Culvert') {
                        content = (
                            <div>
                                <CulvertTable r={cs?.str_table} />
                            </div>
                        );
                    }
                    else if(cs.typeName === 'Bridge') {
                        content = (
                            <div>
                                <BridgeTable r={cs?.str_table} />
                            </div>
                        );
                    }

                    createLeafletPopup({
                        L,
                        content,
                        contentStyle: {
                            overflowY: 'auto',
                            minWidth: HecRasHelper.getWidth(58)
                        },
                        properties: {autoPan: true, maxWidth: HecRasHelper.getWidth(80)},
                        latlng,
                        map
                    })
                })

                mapObjects.current.structureTexts.push(text_marker)
            })
        })
    }

    const loadCrossSections = () => {
        if(mapObjects.current.crossSectionLayer?.remove)
        {
            mapObjects.current.crossSectionLayer.remove()
            mapObjects.current.crossSections = []
        }

        mapObjects.current.crossSectionLayer = L.layerGroup()

        mapData?.cross_sections?.forEach(cs => {
            if(cs.type === 'cross_section') {
                const isSelected = HecRasHelper.isCrossSectionMatch(
                    selectedRS?.cross_section,
                    cs.cross_section,
                    cs.cross_section_value
                );

                const polyline = L.polyline(cs?.xy, { color: isSelected ? 'red' : getColor(cs.cross_section, 'cross_section', tile.csColor), weight: 1, }).addTo(mapObjects.current.crossSectionLayer)
                polyline.cross_section = cs.cross_section
                polyline.search = cs.cross_section
                polyline.on('click', () => {

                })
                mapObjects.current.crossSections.push(polyline)
            }
        })

        mapObjects.current.crossSectionLayer.addTo(map)
    }

    const loadIneffs = () => {
        if(mapObjects.current.ineffLayer?.remove)
        {
            mapObjects.current.ineffLayer.remove();
            mapObjects.current.ineffs = []
        }

        if(!modelLayers.includes('Ineffective Area'))
            return;

        if(map.getZoom() < 17)
            return

        mapObjects.current.ineffLayer = L.layerGroup();
        mapData?.cross_sections?.forEach(cs => {
            if(cs.type === 'cross_section') {
                cs?.ineffs?.forEach(ineff => {
                    const ineff_icon = L.icon({
                        iconUrl: '/icons/ineff_icon.png', // İkon resmi dosya yolu
                        iconSize: [12, 12], // İkon boyutu
                    });
                    mapObjects.current.ineffs.push(L.marker(ineff?.xy, { icon: ineff_icon }).addTo(mapObjects.current.ineffLayer))
                })
            }
        })

        mapObjects.current.ineffLayer.addTo(map)
    }

    const isLoadMannings = () => {
        if(!modelLayers.includes('Mannings n'))
            return false;

        if(mapContext[type]?.zoom < 17)
            return false

        return true
    }

    const loadMannings = () => {
        if(mapObjects.current.manningsLayer?.remove)
        {
            mapObjects.current.manningsLayer.remove();
            mapObjects.current.mannings = []
        }

        if(mapObjects.current.manningsTextLayer?.remove)
        {
            mapObjects.current.manningsTextLayer.remove();
            mapObjects.current.manningsTextLayer = []
        }

        if(!isLoadMannings())
            return

        mapObjects.current.manningsLayer = L.layerGroup().addTo(map);
        mapObjects.current.manningsTextLayer = L.inflatableMarkersGroup({
            iconCreateFunction: function (icon) {return L.divIcon({html: `<div style="color: ${tile.textColor}"></div>`, iconSize: [0,0]});}
        }).addTo(map);

        mapData?.cross_sections?.forEach(cs => {
            if(cs.type === 'cross_section') {
                cs.manns?.forEach(mann => {
                    if(!mann)
                        return

                    mapObjects.current.mannings.push(L.polyline(mann, { color: tile.textColor, weight: 1, }).addTo(mapObjects.current.manningsLayer))
                })

                cs?.manns_text?.forEach(mann_text => {
                    mapObjects.current.manningsTexts.push(
                        L.marker(mann_text?.chord?.xy, {
                            icon: L.divIcon({
                                className: 'dummy',
                                html: `<div style="color:${tile.textColor}; ">n: ${mann_text?.text}</div>`, // Buraya istediğiniz metni ekleyin
                                iconSize: [48, 20], // Metnin boyutu
                                iconAnchor: [0, -15]
                            })
                        }).addTo(mapObjects.current.manningsTextLayer)
                    )
                })
            }
        })
    }

    const loadBankStations = () => {
        if(mapObjects.current.banksLayer?.remove)
        {
            mapObjects.current.banksLayer.remove();
            mapObjects.current.banks = []
        }

        if(!modelLayers.includes('Bank Station'))
            return;

        mapObjects.current.banksLayer = L.layerGroup();
        mapData?.cross_sections?.forEach(cs => {
            if(cs.type === 'cross_section') {
                cs?.banks?.forEach(b => {
                    const bank = L.circle(b?.xy, 0.5, {color: 'red', fillColor: 'red', fillOpacity: 0.5}).addTo(mapObjects.current.banksLayer)

                    const mouseOver = (e) => {
                        const latlng = e.latlng;
                        createLeafletPopup({
                            L,
                            content: (
                                <ResultTable>
                                    <ResultRow>
                                        <ResultHeaderCell style={{textAlign: 'left'}}>RS</ResultHeaderCell>
                                        <ResultBodyCell style={{textAlign: 'left',}}>{cs?.cross_section}</ResultBodyCell>
                                    </ResultRow>
                                    <ResultRow>
                                        <ResultHeaderCell style={{textAlign: 'left'}}>Station</ResultHeaderCell>
                                        <ResultBodyCell style={{textAlign: 'left'}}>{b?.station}</ResultBodyCell>
                                    </ResultRow>
                                    <ResultRow>
                                        <ResultHeaderCell style={{textAlign: 'left'}}>Elevation</ResultHeaderCell>
                                        <ResultBodyCell style={{textAlign: 'left'}}>{b?.elev}</ResultBodyCell>
                                    </ResultRow>
                                </ResultTable>
                            ),
                            contentStyle: {
                                maxHeight: 100,
                                overflowY: 'auto'
                            },
                            properties: {autoPan: true, maxWidth: 200},
                            latlng,
                            map
                        })
                    }
                    bank.on('click', mouseOver)
                    // bank.on('mouseover', mouseOver)

                    mapObjects.current.banks.push(bank)
                })
            }
        })
        mapObjects.current.banksLayer.addTo(map)
    }

    const loadLayers = (zoomChanged) => {
        if(!map)
            return

        if(mapObjects.current.loadLayerTimeout) {
            clearTimeout(mapObjects.current.loadLayerTimeout)
        }

        mapObjects.current.loadLayerTimeout = setTimeout(() => {
            loadRiverStream(zoomChanged)
            loadStructures()
            loadCrossSections()
            loadMultipleOpeningLines()
            loadFloodExtends(profile || mapData.profiles[0])
            loadFlowPaths(profile || mapData.profiles[0])
            loadBlockObstr()
            loadBoundaryTable()
            loadFlowChangeTable()
            loadTexts()
            loadIneffs()
            loadMannings()
            loadBankStations()
        }, 200)
    }

    const clearLayers = () => {
        if(map) {
            map.eachLayer(function (layer) {
                map.removeLayer(layer);
            });
        }
        if(mapObjects.current.tile?.remove)
            mapObjects.current.tile.remove()
        if(mapObjects.current.river?.remove)
            mapObjects.current.river.remove()
        if(mapObjects.current.streamArrow?.remove)
            mapObjects.current.streamArrow.remove()
        if(mapObjects.current.banksLayer?.remove)
            mapObjects.current.banksLayer.remove()
        if(mapObjects.current.manningsLayer?.remove)
            mapObjects.current.manningsLayer.remove()
        if(mapObjects.current.manningsTextLayer?.remove)
            mapObjects.current.manningsTextLayer.remove()
        if(mapObjects.current.ineffLayer?.remove)
            mapObjects.current.ineffLayer.remove()
        if(mapObjects.current.crossSectionLayer?.remove)
            mapObjects.current.crossSectionLayer.remove()
        if(mapObjects.current.crossSectionTextLayer?.remove)
            mapObjects.current.crossSectionTextLayer.remove()
        if(mapObjects.current.flowChangeLayer?.remove)
            mapObjects.current.flowChangeLayer.remove()
        if(mapObjects.current.downstreamBoundary?.remove)
            mapObjects.current.downstreamBoundary.remove()
        if(mapObjects.current.blockObstLayer?.remove)
            mapObjects.current.blockObstLayer.remove()
        if(mapObjects.current.structureLayer?.remove)
            mapObjects.current.structureLayer.remove()
        if(mapObjects.current.structureTextLayer?.remove)
            mapObjects.current.structureTextLayer.remove()
        if(mapObjects.current.multipleOpeningLinesLayer?.remove)
            mapObjects.current.multipleOpeningLinesLayer.remove()
        if(mapObjects.current.floodExtendsLayer?.remove)
            mapObjects.current.floodExtendsLayer.remove()
        if(mapObjects.current.searchLayer?.remove)
            mapObjects.current.searchLayer.remove()
        if(mapObjects.current.textLayer?.remove)
            mapObjects.current.textLayer.remove()
    }

    const onContextMenuMap = async (e) => {
        const elements = document.getElementsByClassName('leaflet-control-coord-projection')
        if(elements?.length > 0) {
            const coordDiv = elements[0]
            const text = coordDiv.innerText.split('|').map(x => x?.trim())?.join('\t')
            await navigator.clipboard.writeText(`${text}\n${e?.latlng?.lat?.toFixed(6)}\t${e?.latlng?.lng?.toFixed(6)}`)
            // Modal.info({
            //     title: ``,
            //     content: (
            //         <>
            //
            //         </>
            //     ),
            //     footer: null
            // })
        }
    }

    const onZoomEnd = (e) => {
        dispatchProject({
            type: AppActions.SET_MAP_ZOOM,
            data: {zoom: map.getZoom(), type}
        })
        // Save to sharedView for B/C sync (using MapSyncContext)
        setSharedView(map.getZoom(), map.getCenter())
    }

    const onMoveEnd = () => {
        // Save to sharedView for B/C sync (using MapSyncContext)
        setSharedView(map.getZoom(), map.getCenter())
    }

    useEffect(() => {
        if(mapContext[type].update !== mapContext[type].prevUpdate) {
            mapContext[type].prevUpdate = mapContext[type].update
            loadLayers(false)
            onChangeLayers()
        }
    }, [mapContext[type].update, highlightSurvey, modelLayers]);

    // LayerSelect Control'ünü güncelle
    useEffect(() => {
        if(mapObjects.current.layerSelectRoot) {
            mapObjects.current.layerSelectRoot.render(
                <LayerSelectLeaflet
                    type={type}
                    projectLayers={projectLayers}
                    onProjectLayerChange={onProjectLayerChange}
                    riverBounding={riverBoundingCoords}
                    mapContext={mapContext}
                    dispatchProject={dispatchProject}
                    ShapeTableComponent={ShapeTable}
                    openModal={openModal}
                    userSettings={user?.settings}
                    user={user}
                    setSettings={setSettings}
                />
            );
        }
    }, [mapContext, projectLayers, riverBoundingCoords, type]);

    // Update ProjectionSelect Control when projection changes
    useEffect(() => {
        if(mapObjects.current.projectionSelectRoot) {
            mapObjects.current.projectionSelectRoot.render(
                <ProjectionSelect
                    projectProjection={projection}
                    activeProjection={activeProjection}
                    onProjectionChange={setActiveProjection}
                    userPreference={userPreferenceProjection}
                />
            );
        }
    }, [activeProjection, projection, userPreferenceProjection]);


    useEffect(() => {
        if(filter?.us || filter?.ds) {
            if(!map)
                return

            loadStructures()
            loadCrossSections()
            loadTexts()
        }
    }, [filter?.us, filter?.ds]);
    //
    useEffect(() => {
        const event = new CustomEvent('change-project-info', {
            detail: {
                [type]: {
                    ...(projectInfo || {}),
                    color: tile.textColor
                }
            }
        });
        window.dispatchEvent(event)
    }, [mapContext[type].update, tile, projectInfo]);
    //
    const runFullExtend = (e) => {
        if(e?.detail?.type === type) {
            setFullExtendEvent(v4())
        }
    }

    // Update typeRef when type changes
    useEffect(() => {
        typeRef.current = type
    }, [type])

    // When becoming visible, apply sharedView to map and invalidateSize
    const prevVisibleRef = useRef(isVisible)
    useEffect(() => {
        // Only run when transitioning from hidden to visible
        if (isVisible && !prevVisibleRef.current && map) {
            setTimeout(() => {
                map.invalidateSize()
                // Apply shared zoom/center from MapSyncContext only if valid
                const sharedView = getSharedView()
                if (sharedView?.zoom && sharedView?.zoom > 0 && sharedView?.center) {
                    map.setView(sharedView.center, sharedView.zoom, { animate: false })
                }
            }, 50)
        }
        prevVisibleRef.current = isVisible
    }, [isVisible])

    // Initialize and update effective projection
    useEffect(() => {
        const initProjection = async () => {
            const effProj = await getEffectiveProjection()
            setActiveProjection(effProj)
        }
        initProjection()
    }, [projection, userPreferenceProjection])

    // Update MouseCoord when projection changes
    useEffect(() => {
        if (mouseCoordRef.current && activeProjection?.text) {
            mouseCoordRef.current.updateProjection(activeProjection.text, activeProjection.name, activeProjection.isProject)
        }
    }, [activeProjection])

    // Keyboard listener for B/C/S keys
    useEffect(() => {
        if (!map || !onTypeChange || isSideBySide) return

        const handleKeyDown = (e) => {
            // Skip if user is typing in an input field
            if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.isContentEditable) {
                return
            }

            // Skip if any modifier key is pressed (Ctrl, Alt, Shift, Meta)
            if (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey) {
                return
            }

            const key = e.key.toLowerCase()
            if (key === 'b') {
                onTypeChange('base')
            } else if (key === 'c' && hasCompareData) {
                onTypeChange('compare')
            } else if (key === 's' && hasCompareData) {
                onTypeChange('sidebyside')
            }
        }

        window.addEventListener('keydown', handleKeyDown)
        return () => {
            window.removeEventListener('keydown', handleKeyDown)
        }
    }, [map, onTypeChange, hasCompareData, isSideBySide])

    // Update MapTypeSwitch button when type changes
    useEffect(() => {
        if (mapObjects.current.mapTypeSwitchRoot && onTypeChange) {
            mapObjects.current.mapTypeSwitchRoot.render(
                <MapTypeSwitchButton 
                    currentType={buttonType} 
                    onTypeChange={onTypeChange} 
                    hasCompareData={hasCompareData}
                />
            )
        }
    }, [buttonType, hasCompareData])

    useEffect(() => {
        if(map && !isReady.current) {
            isReady.current = true

            loadToolbar()
            loadPlugins()

            map.on('moveend', onMoveEnd)
            map.on('zoomend', onZoomEnd)
            map.on('contextmenu', onContextMenuMap)

            // Save initial view to sharedView for B/C sync (using MapSyncContext)
            if (isVisible) {
                setSharedView(map.getZoom(), map.getCenter())
            }

            window.addEventListener('resize', handleResize);
            window.addEventListener('full-extend', runFullExtend);

            return () => {
                window.removeEventListener('resize', handleResize);
                window.removeEventListener('full-extend', runFullExtend);
                map.off('moveend', onMoveEnd)
                map.off('zoomend', onZoomEnd)

                dispatchProject({
                    type: AppActions.SET_MESSAGE_TOOLBAR_ITEM,
                    data: {toolbar: null}
                })

                clearLayers()
            };
        }

        return () => {
            if(map) {
                map.off('contextmenu', onContextMenuMap)
            }
        }
    }, [map]);

    useEffect(() => {
        if(fullExtendEvent) {
            fullExtend()
        }
    }, [fullExtendEvent]);

    useEffect(() => {
        if(mapData && map && profile?.target) {
            loadFloodExtends(profile)
            loadFlowPaths(profile)
        }
    }, [profile?.target]);

    useEffect(() => {

        if(mapData && map) {
            if(mapObjects.current.tile) {
                map.removeLayer(mapObjects.current.tile)
                mapObjects.current.tile = null
            }

            // White background için beyaz GridLayer oluştur
            if(tile.isBlank) {
                const WhiteLayer = L.GridLayer.extend({
                    createTile: function() {
                        const tile = document.createElement('canvas');
                        const size = this.getTileSize();
                        tile.width = size.x;
                        tile.height = size.y;
                        const ctx = tile.getContext('2d');
                        ctx.fillStyle = 'white';
                        ctx.fillRect(0, 0, size.x, size.y);
                        return tile;
                    }
                });
                mapObjects.current.tile = new WhiteLayer({maxZoom: 25})
                mapObjects.current.tile.addTo(map)
            } else {
                mapObjects.current.tile = window.L.tileLayer(tile.url, tile.options || {maxZoom: 35})
                mapObjects.current.tile.addTo(map)
            }

            loadLayers(false)
        }
    }, [tile, map]);

    useEffect(() => {
        if(mapContext[type]?.zoom && map && mapData) {
            loadLayers(true)
        }

    }, [mapContext[type]?.zoom]);

    useEffect(() => {
        if(map && mapData) {
            if(selectedRS?.cross_section)
            {
                loadLayers(false)
                setRS2MapCenter(!prevSelectedRS.current ? 18 : map.getZoom())
                prevSelectedRS.current = selectedRS?.cross_section
            }
            else {
                fullExtend()
            }
        }
    }, [selectedRS?.cross_section, map]);


    useEffect(() => {
        if(map && mapData) {
            loadLayers(false)
        }
    }, [updateKey]);


    useEffect(() => {
        const containerId = isSideBySide ? `map-container-tab-${type}` : 'map-container-tab'
        const mapContainer = document.getElementById(containerId)
        if(mapContainer && map) {
            try {
                mapContainer.style.width = `${size.width}px`;
                mapContainer.style.height = `${size.height}px`;
                map.invalidateSize();
            } catch (e) {
                // Ignore invalidateSize errors during side-by-side initialization
            }
        }
    }, [size, type, isSideBySide]);

    // Generate unique container ID for side-by-side mode
    const containerId = isSideBySide ? `map-container-tab-${type}` : 'map-container-tab'

    return (
        <div key={`map-tab-${type}`}>
            {/* FEMA Loading Progress Modal */}
            {femaProgress && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.45)',
                    zIndex: 1000,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <div style={{
                        background: 'white',
                        borderRadius: 8,
                        padding: '20px 24px',
                        minWidth: 320,
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                    }}>
                        <div style={{ fontSize: 16, fontWeight: 500, marginBottom: 16 }}>
                            Loading FEMA NFHL Data...
                        </div>
                        <Progress 
                            percent={Math.round((femaProgress.current / femaProgress.total) * 100)} 
                            status="active" 
                        />
                        <div style={{ marginTop: 12, fontSize: 13, color: '#666' }}>
                            <div>Grid cells: <b>{femaProgress.current}</b> / {femaProgress.total} ({femaProgress.numCols}x{femaProgress.numRows})</div>
                            <div>Features found: <b>{femaProgress.features}</b></div>
                            {femaProgress.errors > 0 && <div style={{ color: '#ff4d4f' }}>Errors: {femaProgress.errors}</div>}
                        </div>
                    </div>
                </div>
            )}
            <MapContainer
                id={containerId}
                center={[51.505, -0.09]}
                zoom={mapContext[type]?.zoom}
                zoomSnap={0.1}
                popupMovable={true}
                style={{ height: size.height, width: size.width, backgroundColor: 'white' }}
                whenReady={(_map) => {
                    setMap(_map.target)
                    if (onMapReady) {
                        onMapReady(_map.target)
                    }
                }}
            >

            </MapContainer>
        </div>
    )
}